<template>
    <div class="visitor-activities">
        <ActivityListView :activities="activities" @load-more="loadMore" :loading="loading" />
    </div>
</template>

<script>
import { ACTIVITY_API } from "../../../api/activity";
import { log2 } from "../../../utils/log2";
import ActivityListView from "../Activity/ActivityListView.vue";

const log = log2("VisitorActivities");

export default {
    name: "VisitorActivities",
    components: {
        ActivityListView,
    },
    props: {
        visitorId: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        filter: {
            visitorId: null,
        },
        activities: [],
        total: 0,
        cursor: {
            page: 1,
            perPage: 50,
        },
        loading: false,
    }),
    methods: {
        fetchActivities(pagination) {
            this.loading = true;
            ACTIVITY_API.ACTIVITY.list(this.cursor, {
                visitorId: this.visitorId,
            })
                .then((res) => {
                    const { count, items } = res.data;
                    this.activities = this.$_.uniqBy(pagination ? [...this.activities, ...items] : items, (q) => q._id);
                    this.total = count;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        loadMore() {
            if (Math.ceil(this.total / this.cursor.perPage) > this.cursor.page) {
                this.cursor.page = this.cursor.page + 1;
            }
        },
    },
    mounted() {
        this.fetchActivities();
    },
    watch: {
        cursor: {
            deep: true,
            handler() {
                this.fetchActivities(true);
            },
        },
    },
};
</script>

<style lang="scss">
.visitor-activities {
    overflow-y: auto;
}
</style>
